import React from 'react';
import { Icon } from 'semantic-ui-react';
import { Chip as ChipRoot, ChipLabel, ChipRemove, ChipValue } from './styles';

export type ChipProps = {
  label: string;
  value: string;
  onRemove?: () => void;
};

const Chip: React.FC<ChipProps> = ({ label, value, onRemove }) => {
  return (
    <ChipRoot>
      <ChipLabel>{label}:</ChipLabel>
      <ChipValue>{value}</ChipValue>
      {onRemove && (
        <ChipRemove
          type="button"
          aria-label={`Remover filtro ${label}`}
          onClick={onRemove}
        >
          <Icon name="close" />
        </ChipRemove>
      )}
    </ChipRoot>
  );
};

export default Chip;
